export default __webpack_public_path__ + "static/media/94.bc690b6a.png";